import { render, staticRenderFns } from "./BrushIcon.vue?vue&type=template&id=6c412b92&scoped=true"
import script from "./BrushIcon.vue?vue&type=script&lang=js"
export * from "./BrushIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c412b92",
  null
  
)

export default component.exports